import { useEffect } from "react";
import Select from "react-select";
import { Table } from "react-bootstrap";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

import { decimalValidateNew, formatMilesDecimalNew } from "@/services/Utils";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";

const IrrigationsBusinessCenter = ({ data, handleInputChange, handleAddRow, handleDelete, business_center }) => {
	useEffect(() => {
		if (data.businessCenters.length === 0) {
			handleAddRow();
		}
		// eslint-disable-next-line
	}, [data.businessCenters]);

	const filteredBusinessCenters = business_center.filter((bc) => bc.estates.some((estate) => data.estates.includes(estate)));

	return (
		<Table>
			<thead>
				<tr>
					<th className="border-0">Centro de Costo</th>
					<th className="border-0">Superficie Centro de Costo (ha)</th>
					<th className="border-0">Superficie Riego (ha)</th>
					<th className="border-0">Acciones</th>
				</tr>
			</thead>
			<tbody>
				{data &&
					data.businessCenters.map((item, index) => (
						<tr key={index}>
							<td style={{ padding: "5px" }}>
								<Select
									key={`item_${index}`}
									options={filteredBusinessCenters}
									onChange={(e) => handleInputChange(index, "business_center_id", e)}
									value={business_center.find((option) => option.value === item.business_center_id)}
									isSelectAll={true}
									menuPlacement={"bottom"}
									placeholder={"Seleccionar..."}
									isClearable={false}
									styles={{
										placeholder: (provided) => ({
											...provided,
											fontSize: "12px",
										}),
									}}
									components={{
										NoOptionsMessage,
									}}
								/>
							</td>
							<td style={{ padding: "5px", textAlign: "center" }}>{formatMilesDecimalNew(item.total_ha)}</td>
							<td style={{ padding: "5px" }}>
								<input
									type="text"
									className={`form-control text-right`}
									placeholder="(ha)"
									required
									value={item.ha ? formatMilesDecimalNew(item.ha) : ""}
									onChange={(e) => {
										const value = formatMilesDecimalNew(e.target.value);
										handleInputChange(index, "ha", value);
									}}
									onKeyDown={decimalValidateNew}
								/>
							</td>
							<td style={{ padding: "5px" }} className="table-td-implementation input-text text-center">
								<div className="btn-group">
									<RemoveSvg style={{ cursor: "pointer", width: "1.5em", height: "1.5em" }} onClick={() => handleDelete(index)} />
								</div>
							</td>
						</tr>
					))}
				<tr>
					<td className="border-0">
						<button
							className="btn bg-agro-outline-color btn-block tr-btn"
							onClick={handleAddRow}
							style={{ height: "30px", fontSize: "12px", width: "200px" }}
						>
							<i className="ti-plus"></i> Agregar
						</button>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

export default IrrigationsBusinessCenter;
